
import { pxToRem } from "utility/getFontValue"

export default function Alert() {
  return {
    MuiTabs:{
      styleOverrides:{
        indicator:{
          zIndex: 100
        }
      }
    },
    MuiTab:{
      styleOverrides:{
        root:{
          // fontSize: pxToRem(16),
          // fontWeight: 600,
          // borderRadius: "8px 8px 0px 0px",
          // "&.Mui-selected": {
          //   backgroundColor: "#ffffff",
          // },
          // minWidth: 160
        },
      }
    }
  };
}
